import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../services/api';
import { useAuth } from '../AuthContext';
import './GeneralDashboard.css';

const GeneralDashboard = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const response = await API.get('/api/general-dashboard');
        
        if (response.data && response.data.success) {
          setDashboardData(response.data);
        } else {
          throw new Error(response.data?.message || 'Failed to fetch dashboard data');
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setError(error.message || 'An error occurred while fetching dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return <div className="loading">Loading employee dashboard...</div>;
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Error</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="general-dashboard">
      <h1>Employee Dashboard</h1>
      <p>Welcome, {user?.firstName || 'Employee'}!</p>
      
      <div className="dashboard-actions">
        <Link to="/incident-reports" className="dashboard-action-button">
          View Incident Reports
        </Link>
        <Link to="/profile" className="dashboard-action-button">
          My Profile
        </Link>
      </div>
      
      <div className="dashboard-notices">
        <h2>Notices & Updates</h2>
        {dashboardData?.data?.notices?.map(notice => (
          <div key={notice.id} className="notice-card">
            <h3>{notice.title}</h3>
            <p>{notice.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneralDashboard;